import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalService } from 'app/common/services/modal.service';
import { iconDownload, iconPublish, iconSave, iconStore, iconTrash } from 'app/common/utils/icons.utils';
import { IngrediantService } from 'app/services/ingrediant.service';
import { ReceipeDTO, Recipe } from 'app/models/recipe.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/services/toasts.service';

import { Gtag } from 'angular-gtag';
import { AuthService } from 'app/auth-core/auth.service';
import { BaseComponent } from 'app/common/components/base.component';
import { RecipeService } from 'app/services/recipe.service';
import { RecipePage } from 'app/pages/switch-data-analisys/receipt-creation/receipt-creation.component';

@Component({
	selector: 'my-receipt-editor',
	templateUrl: '../../../switch-data-analisys/receipt-creation/receipt-creation.component.html',
	styleUrls: ['../../../switch-data-analisys/receipt-creation/receipt-creation.component.scss']
})
export class EditMyRecipePage extends RecipePage {
	
	ngOnInit(): void {
		console.log("Eccomi.....");
		
		this.on(
			this.authService.isAuthenticated$.subscribe((isAutenticated) => {
				this.isAutenticated = isAutenticated;
				if (isAutenticated && !this.recipe) {
					this._activatedRoute.paramMap.subscribe((params) => {
						this.showGoBack = true;
						if (params.get("recipeId")) {
							this._recipeService.getMyRecipe(params.get("recipeId")).subscribe((recipe) => {
								this.recipe = recipe;
								this.pageLoaded = true;								
							})
						}
						else {
							this.pageLoaded = true;
						}
					})
				}
			})
		)
	}
}